function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import includes from 'lodash/includes';
import map from 'lodash/map';
import valuesIn from 'lodash/valuesIn';
import OptionBox from 'components/Form/OptionBox';
import messages from '../../messages';
import * as constants from '../../constants';
import * as shapes from '../../shapes';
import styles from '../Boxes.pcss';
var _React_PureComponent;
class Scope extends (_React_PureComponent = React.PureComponent) {
    renderScopeBox(scopeName, formValue) {
        const isDisabled = !includes(this.props.activeScopeNames, scopeName);
        if (isDisabled && this.props.hideInactive) {
            return null;
        }
        return /*#__PURE__*/ _jsx(OptionBox, {
            id: "scopeName",
            value: formValue,
            inputValue: scopeName,
            labelMessage: messages.scopes[scopeName],
            infoMessage: messages.scopeInfos[scopeName],
            isDisabled: isDisabled,
            onChange: this.props.onSetFormValue
        }, scopeName);
    }
    render() {
        if (this.props.isHidden) {
            return null;
        }
        const formValue = get(this.props.formValues, 'values.scopeName');
        return map(valuesIn(constants.SCOPE_NAMES), (scopeName)=>this.renderScopeBox(scopeName, formValue));
    }
}
_define_property(Scope, "propTypes", {
    activeScopeNames: PropTypes.arrayOf(shapes.scopeName),
    hideInactive: PropTypes.bool,
    isHidden: PropTypes.bool,
    formValues: PropTypes.object,
    onSetFormValue: PropTypes.func
});
_define_property(Scope, "defaultProps", {
    activeScopeNames: valuesIn(constants.SCOPE_NAMES),
    hideInactive: false,
    isHidden: false
});
export default withStyles(styles)(Scope);
